export default __webpack_public_path__ + "img/label.puroak.01.asset.5e2555ab.png";